import { Timestamp } from 'firebase/firestore';

const normalizeDate = (date: Date | Timestamp | string | undefined): Date => {
    if (!date) return new Date();
    if (date instanceof Date) return date;
    if (typeof date === 'string') return new Date(date);
    if (date && typeof date === 'object' && 'toDate' in date) {
        return (date as Timestamp).toDate();
    }
    return new Date();
};

export default normalizeDate;
